module.exports = __webpack_public_path__ + "img/course-1-1.91ffd472.jpeg";